<div class="not-found-error-page">
  <mode-confetti-layout>
    <mode-error-prompt [title]="errorTitle" [explanation]="errorExplanation" [instructions]="errorInstructions">
      <mode-error-prompt-actions>
        <capra-button-link
          data-test="home-button-link"
          [text]="errorPrimaryActionLabel"
          [href]="errorPrimaryActionTarget"
        />
      </mode-error-prompt-actions>
    </mode-error-prompt>
  </mode-confetti-layout>
</div>
